<div class="text-center mt-4 cursor-pointer" (mouseleave)="backToDefault()">
  <ng-container *ngFor="let star of starsArray">
    <span
      (mouseenter)="changeFilled(star)"
      class="inline-block star-icon"
      *ngIf="!star.filled"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.932 22.239">
        <path
          d="M4919.279,3097.68l-5.25-3.909a.412.412,0,1,0-.822,0l-5.25,3.909a1.712,1.712,0,0,1-2.644-1.924l2.092-6.2c.014-.041.029-.082.045-.121l-5-3.17a1.714,1.714,0,0,1,.846-3.16l6.538-.27a1.737,1.737,0,0,1,.428.035l1.836-5.878a1.714,1.714,0,0,1,3.271,0l1.829,5.845a1.778,1.778,0,0,1,.2,0l6.538.27a1.714,1.714,0,0,1,.846,3.16l-5,3.169c.017.04.032.08.046.122l2.092,6.2a1.72,1.72,0,0,1-1.629,2.271A1.683,1.683,0,0,1,4919.279,3097.68Z"
          transform="translate(-4901.652 -3075.788)"
          fill="#d8d8d8"
        />
      </svg>
    </span>
    <span
      (click)="fillAndChangeValue(star)"
      (mouseenter)="changeFilled(star)"
      class="inline-block star-icon"
      *ngIf="star.filled"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.932 22.239">
        <path
          d="M4919.279,3097.68l-5.25-3.909a.412.412,0,1,0-.822,0l-5.25,3.909a1.712,1.712,0,0,1-2.644-1.924l2.092-6.2c.014-.041.029-.082.045-.121l-5-3.17a1.714,1.714,0,0,1,.846-3.16l6.538-.27a1.737,1.737,0,0,1,.428.035l1.836-5.878a1.714,1.714,0,0,1,3.271,0l1.829,5.845a1.778,1.778,0,0,1,.2,0l6.538.27a1.714,1.714,0,0,1,.846,3.16l-5,3.169c.017.04.032.08.046.122l2.092,6.2a1.72,1.72,0,0,1-1.629,2.271A1.683,1.683,0,0,1,4919.279,3097.68Z"
          transform="translate(-4901.652 -3075.788)"
          fill="#FFD500"
        />
      </svg>
    </span>
  </ng-container>
</div>
